import React, { Component } from "react";
import { withRouter } from "react-router";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import Searchbox from "../controls/Searchbox";
import CustomTabs from "../controls/Tabs";
import TabContainer from "../controls/TabContainer";
import Cancel from "material-ui-icons/Cancel";
import DeleteForever from "material-ui-icons/DeleteForever";
import Select from "react-select";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap';

const styles = theme => ({
  root: {
    padding: 10
  },
  tabHolder: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  tab: {
    boxShadow: "none"
  },
  tabItem: {
    fontSize: "12px"
  },
  indicator: {
    backgroundColor: "#3f51b5"
  },
  wrapper: {
    marginTop: 20,
    position: "relative"
  }
});

class CashAdd extends Component {
  state = {
    modal: false,
    value: 0
  };

  componentDidMount() {
    if (this.props.history.location.pathname === "/expense") {
      this.setState({ value: 0 });
    } else {
      this.setState({ value: 1 });
    }
  }

  handleChange = (event, value) => {
    if (value === 0) {
      this.props.history.push("/expense");
    } else {
      this.props.history.push("/expensetypes");
    }
    this.setState({ value });
  };
  
  toggle = modalType => () => {
    if (!modalType) {
      return this.setState({
        modal: !this.state.modal,
      });
    }

    this.setState({
      [`modal_${modalType}`]: !this.state[`modal_${modalType}`],
    });
  };

  render() {
    const { classes } = this.props;
    const { value, clearSearch } = this.state;
    const options = [
      {value:"Cash", label: "Cash"},
      {value:"Check", label: "Check"},
      {value:"Pop", label: "Pop"},
      {value:"Credit Card", label: "Credit Card"},
    ]

    return (
      <div className={classes.wrapper}>
        <div>
          <Button
            className={classes.button}
            variant="raised"
            color="default"
            size="small"
            onClick={this.onListClick}
          >
            List
          </Button>

          <Button
            className={classes.button}
            variant="raised"
            color="primary"
            size="small"
            onClick={this.toggle()}
          >
            Create New
          </Button>
          <Searchbox
            clear={clearSearch}
            onChange={this.onSearchChange}
            onSubmit={this.onSearchSubmit}
          />
        </div>

        <div className={classes.tabHolder}>
          <table className="customtable">
            <thead className="customthead">
            <tr className="customtr">
              <th>#</th>
              <th>Drawer ID</th>
              <th>Drawer Name</th>
              <th>Date</th>
              <th>Tender Type</th>
              <th>Amount (RM)</th>
              <th>Close</th>
              <th>Actions</th>
            </tr>
            </thead>
            <tr className="customtr">
              <td>1</td>
              <td>Alan-0085</td>
              <td>Alan Borela</td>
              <td>12 Jan 2021</td>
              <td><Select options={options} value={options[0]} /></td>
              <td>123.22</td>
              <td><input type="checkbox"></input></td>
              <td className="button"><DeleteForever/></td>
            </tr>
            <tr className="customtr">
              <td>2</td>
              <td>Alan-0085</td>
              <td>Alan Borela</td>
              <td>23 Mar 2021</td>
              <td><Select options={options} value={options[1]} /></td>
              <td>33.00</td>
              <td><input type="checkbox"></input></td>
              <td className="button"><DeleteForever/></td>
            </tr>
            <tr className="customtr">
              <td>3</td>
              <td>Alan-0085</td>
              <td>Alan Borela</td>
              <td>28 Mar 2021</td>
              <td><Select options={options} value={options[2]} /></td>
              <td>123.22</td>
              <td><input type="checkbox"></input></td>
              <td className="button"><DeleteForever/></td>
            </tr>
            <tr className="customtr">
              <td>4</td>
              <td>Alan-0085</td>
              <td>Alan Borela</td>
              <td>12 Apr 2021</td>
              <td><Select options={options} value={options[3]} /></td>
              <td>63.22</td>
              <td><input type="checkbox"></input></td>
              <td className="button"><DeleteForever/></td>
            </tr>
            <tr className="customtr">
              <td>5</td>
              <td>Alan-0085</td>
              <td>Alan Borela</td>
              <td>18 July 2021</td>
              <td><Select options={options} value={options[0]} /></td>
              <td>99.00</td>
              <td><input type="checkbox"></input></td>
              <td className="button"><DeleteForever/></td>
            </tr>
          </table>
        </div>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}>
          <ModalHeader toggle={this.toggle()}>Create New Cash Add</ModalHeader>
          <ModalBody>
          <table>
            <tr>
              <td style={{width:"150px"}}><b>Drawer ID</b></td>
              <td>Alan-0085</td>
            </tr>
            <tr>
              <td><b>Drawer Name</b></td>
              <td>Alan Borela</td>
            </tr>
            <tr>
              <td><b>Date</b></td>
              <td><input type="date"/></td>
            </tr>
            <tr>
              <td><b>Tender Type</b></td>
              <td><Select options={options} value={options[0]} /></td>
            </tr>
            <tr>
              <td><b>Amount</b></td>
              <td><input type="number"/></td>
            </tr>
          </table>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggle()}>
              Cancel
            </Button>
            <Button color="primary" onClick={this.toggle()}>
              Create
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(CashAdd));



// WEBPACK FOOTER //
// ./src/components/misc/CashAdd.js